import { Field } from "react-final-form";
import { useState, Fragment } from "react";

const MultipleSelect = ({ title, required, items, name, validate }) => {
  const [checked, setChecked] = useState([]);
  const [bypass, setBypass] = useState(false);

  const handleOnChange = (name, input) => {
    const parsed = checked.includes(name)
      ? checked.filter((element) => element !== name)
      : [...checked, name];
    setChecked(parsed);
    input.onChange(parsed.join(","));
  };

  return (
    <div
      className="flex flex-col items-start justify-start"
      onClick={() => setBypass(true)}
    >
      <label className={`Form-label ${required && "is-required"}`}>
        {title}
      </label>

      <div
        className={`rounded-tr-lg rounded-bl-lg border pl-5 pr-2 py-6 mt-1 flex flex-col space-y-3 overflow-y-scroll max-h-[200px] w-full ${
          !checked.length && bypass ? "border-red-brand" : "border-[#c7c7c7]"
        }`}
      >
        <Field name={name} type="text" required={required} validate={validate}>
          {({ input }) =>
            items.map(({ label, name }, key) => (
              <Fragment key={key}>
                <InputCheckbox
                  className="text-sm"
                  label={label}
                  onChange={() => handleOnChange(name, input)}
                />
              </Fragment>
            ))
          }
        </Field>
      </div>

      {!checked.length && bypass && (
        <div className="text-red-brand text-sm mt-1">
          Trebuie selectata minim o optiune
        </div>
      )}
    </div>
  );
};

const InputCheckbox = ({ className, label, onChange }) => (
  <>
    <label className={`Form-checkbox flex ${className ? className : ""}`}>
      <input
        type="checkbox"
        className="checkbox-input opacity-0 w-0 h-0"
        onChange={onChange}
      />

      <span className="checkbox-control flex-none w-5 h-5 p-1 mr-2 border-gray-light border rounded-4px bg-white cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            d="M1.73 12.91l6.37 6.37L22.79 4.59"
          />
        </svg>
      </span>

      <div className="inline-block label cursor-pointer">
        {typeof label === "string" ? (
          <span dangerouslySetInnerHTML={{ __html: label }}></span>
        ) : (
          label
        )}
      </div>
    </label>
  </>
);

export default MultipleSelect;
